/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventPaymentDialogController', DinghyEventPaymentDialogController);

    DinghyEventPaymentDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entityDinghyEvent', 'BoardPayment', 'DateUtils', '$http'];

    function DinghyEventPaymentDialogController ($timeout, $scope, $uibModalInstance, entity, entityDinghyEvent, BoardPayment, DateUtils, $http) {
        var vm = this;

        if (entityDinghyEvent.closed) {
            $timeout(function() {
                clear();
            });
        }
        vm.payment = entity;
        vm.maxAmount = vm.payment.amount;
        if (vm.payment.parent !== null) {
            vm.maxAmount = vm.payment.amount + vm.payment.parent.amount;
        }
        vm.clear = clear;
        vm.save = save;
        vm.getDept = getDept;
        vm.copyPayment = copyPayment;
        vm.amountEditable = false;

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.payment.dept == "") {
                vm.payment.dept = null;
            }
            if(vm.payment.category == "") {
                vm.payment.category = null;
            }
            BoardPayment.update(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getDept(val) {
            return $http.get('api/_search/depts/', {
                params: {
                    query: val,
                    dinghyEventId: vm.payment.dinghyEvent.id
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function copyPayment() {
            $http.get('/api/payments/duplicate/', {
                params: {
                    paymentId: vm.payment.id
                }
            }).then(onSaveSuccess, onSaveError);
        }
    }
})();
